// biome-ignore lint/correctness/noUnusedImports: imported for side effects or type usage
import React, { type FC } from 'react';

import AlertTriangle from '@crehana/compass.icons.outline/AlertTriangle';
import CloseSmall from '@crehana/compass.icons.outline/CloseSmall';

import type { TPopperErrorProps } from '../types';

const PopperError: FC<TPopperErrorProps> = ({
  title,
  body,
  button,
  onClick,
  onDismiss,
}) => {
  return (
    <div className="tw-rounded-0.4 tw-pt-1.2 tw-pr-1.2 tw-pb-2 tw-pl-2.4 tw-max-w-28">
      <div className="tw-flex tw-justify-between tw-pb-0.8">
        <AlertTriangle size={20} className="tw-mt-1.2 tw-text-alert-500" />
        <div
          className="tw-cursor-pointer"
          onClick={onDismiss}
          onKeyDown={event => {
            if (event.key === 'Esc') {
              onDismiss?.();
            }
          }}
          role="button"
          tabIndex={0}
        >
          <CloseSmall size={24} className="tw-text-neutral-light-600" />
        </div>
      </div>
      <p className="tw-font-subtitle5 tw-pb-1.2 tw-text-neutral-light-800 tw-whitespace-pre-line">
        {title}
      </p>
      <p className="tw-font-body5 tw-pb-1.2 tw-text-neutral-light-800 tw-whitespace-pre-line">
        {body}
      </p>
      {button && (
        <button
          onClick={onClick}
          className="tw-tw-flex tw-text-primary-light-500 tw-items-center tw-font-subtitle5 tw-cursor-pointer"
          type="button"
        >
          {button}
        </button>
      )}
    </div>
  );
};

export default PopperError;
